import { IFormErrors } from '@interfaces/IFormsErrors';
import {
  IActionDealHistory,
  IApplicants,
  IContractCredentials,
  IDealByID,
  IDealsPagination,
  IDiscount,
  IEnrolleeData,
  IEnrollPresentationDataPagination,
  IGetTokenForLeadForm,
  ILeadData,
  ILeadDocument,
  ILeadPagination,
  ILeadQRRegisterMutation,
  ILeadStatuses,
  IPaymentFullHistory,
  IPayments,
  IPresentationInfo,
  ITaskFile,
  ITaskFull,
  ITaskWithPagination,
} from '@interfaces/ISales';
import { IUsersPagination } from '@interfaces/IUser';

export interface ISalesViewState {
  leadForm: {
    data: IGetTokenForLeadForm | null;
    isLoading: boolean;
  };
  leadStatuses: {
    data: ILeadStatuses[] | null;
    isLoading: boolean;
  };
  presentation: {
    data: IPresentationInfo | null;
    isLoading: boolean;
  };
  enrollees: {
    data: IUsersPagination | IEnrolleeData | null;
    isLoading: boolean;
  };
  enrolleesInPresentation: {
    data: IEnrollPresentationDataPagination | null;
    isLoading: boolean;
  };
  leads: {
    data: ILeadPagination | null;
    isLoading: boolean;
  };
  lead_by_qr: {
    data: ILeadQRRegisterMutation | null;
    isLoading: boolean;
  };
  lead: {
    data: ILeadData | null;
    isLoading: boolean;
  };
  tasks: {
    data: ITaskWithPagination | null;
    isLoading: boolean;
  };
  task: {
    data: ITaskFull | null;
    isLoading: boolean;
  };
  taskFiles: {
    data: ITaskFile[] | null;
    isLoading: boolean;
  };
  contractCredentials: {
    data: IContractCredentials[] | null;
    isLoading: boolean;
  };
  lead_documents: {
    data: ILeadDocument[] | null;
    isLoading: boolean;
  };
  lead_contract: {
    data: string | null;
    isLoading: boolean;
  };
  payments: {
    data: IPayments | null;
    isLoading: boolean;
  };
  payments_full_view: {
    data: IPaymentFullHistory | null;
    isLoading: boolean;
  };
  deals: {
    data: IDealsPagination | null;
    oneDeal: IDealByID | null;
    isLoading: boolean;
  };
  discounts: {
    data: IDiscount[] | null;
    isLoading: boolean;
  };
  applicants: {
    data: IApplicants | null;
    isLoading: boolean;
  };
  deal_history: {
    data: IActionDealHistory[] | null;
    isLoading: boolean;
  };
  isLoading: boolean;
  errors: IFormErrors | null;
}

export const initialsSalesViewState: ISalesViewState = {
  leadForm: {
    data: null,
    isLoading: false,
  },
  leadStatuses: {
    data: null,
    isLoading: false,
  },
  presentation: {
    data: null,
    isLoading: false,
  },
  enrollees: {
    data: null,
    isLoading: false,
  },
  enrolleesInPresentation: {
    data: null,
    isLoading: false,
  },
  leads: {
    data: null,
    isLoading: false,
  },
  lead: {
    data: null,
    isLoading: false,
  },
  lead_by_qr: {
    data: null,
    isLoading: false,
  },
  tasks: {
    data: null,
    isLoading: false,
  },
  task: {
    data: null,
    isLoading: false,
  },
  taskFiles: {
    data: null,
    isLoading: false,
  },
  contractCredentials: {
    data: null,
    isLoading: false,
  },
  lead_documents: {
    data: null,
    isLoading: false,
  },
  lead_contract: {
    data: null,
    isLoading: false,
  },
  deals: {
    data: null,
    oneDeal: null,
    isLoading: false,
  },
  payments: {
    data: null,
    isLoading: false,
  },
  payments_full_view: {
    data: null,
    isLoading: false,
  },
  discounts: {
    data: null,
    isLoading: false,
  },
  applicants: {
    data: null,
    isLoading: false,
  },
  deal_history: {
    data: null,
    isLoading: false,
  },
  errors: null,
  isLoading: false,
};
